export default __webpack_public_path__ + "static/media/BrainlabNowW05-Medium.501a91da.woff2";